/**
 *
 * @param {Event} e
 * @param {String} selector
 * @returns {HTMLElement|null}
 */
export function getElementFromEvent(e, selector) {
	if (!e.target) {
		return null;
	}

	const el = e.target?.closest(selector);

	if (!el) {
		return null;
	}

	return el;
}

export function isTouch() {
	const touchDevice = 'ontouchstart' in document.documentElement;
	const smallScreen = window.matchMedia('only screen and (max-width: 768px)').matches;

	return touchDevice && smallScreen;
}

export function serializeArray(form) {
	var field,
		l,
		s = [];
	if (typeof form == 'object' && form.nodeName == 'FORM') {
		var len = form.elements.length;
		for (var i = 0; i < len; i++) {
			field = form.elements[i];
			if (
				field.name &&
				!field.disabled &&
				field.type != 'file' &&
				field.type != 'reset' &&
				field.type != 'submit' &&
				field.type != 'button'
			) {
				if (field.type == 'select-multiple') {
					l = form.elements[i].options.length;
					for (j = 0; j < l; j++) {
						if (field.options[j].selected)
							s[s.length] = { name: field.name, value: field.options[j].value };
					}
				} else if ((field.type != 'checkbox' && field.type != 'radio') || field.checked) {
					s[s.length] = { name: field.name, value: field.value };
				}
			}
		}
	}
	return s;
}

// Video wordt niet scherper gerenderd dan dit aantal beeldpunten per CSS-pixel.
// Bij bewegend beeld is een zachtere bron veel minder zichtbaar dan bij een
// stilstaand plaatje, terwijl het bestand een stuk kleiner is. Zonder dit
// plafond vraagt een kader van 334px op een retinascherm al om 668px bron
const MAX_PIXEL_RATIO = 1.2;

// Een bron mag tot dit deel van de gevraagde breedte kleiner zijn. Zonder die
// marge tikt een kader dat een paar pixels breder is meteen door naar de
// volgende rendition, en die is zomaar anderhalf keer zo groot
const SOURCE_TOLERANCE = 0.85;

// Onder deze rendition wordt niet gekozen, ook niet als het kader klein is: de
// laagste renditions van Bunny hebben zo weinig bitrate dat ze er ook op een
// klein vlak vlekkerig uitzien. De hoogte is de maat waarop Bunny zijn
// bestanden maakt, dus de enige die los van de verhouding van de video staat
const MIN_SOURCE_HEIGHT = 360;

/**
 * Kiest de <source> die het beste past bij de weergavegrootte van de video en
 * zet die als src. De sources hebben een data-sourcewidth en data-sourceheight
 * met hun afmetingen; met data-quality kan een video bewust scherper (> 1) of
 * zachter (< 1) dan het plafond gezet worden.
 *
 * @param {HTMLVideoElement} video
 * @returns {String|null} de gekozen url
 */
export function selectMatchingVideoSource(video) {
	if (!video) {
		return null;
	}

	const all = Array.from(video.querySelectorAll('source[data-sourcewidth]')).sort(
		(a, b) => Number(a.dataset.sourcewidth) - Number(b.dataset.sourcewidth)
	);

	if (!all.length) {
		return null;
	}

	// Zonder data-sourceheight valt er niets af te wijzen, en van een video die
	// alleen in lage renditions bestaat is de bodem ook geen keuze
	const allowed = all.filter((source) => Number(source.dataset.sourceheight) >= MIN_SOURCE_HEIGHT);
	const sources = allowed.length ? allowed : all;

	const rect = video.getBoundingClientRect();

	// Rekening houden met de pixeldichtheid van het scherm, tot het plafond
	const ratio =
		Math.min(window.devicePixelRatio || 1, MAX_PIXEL_RATIO) * (Number(video.dataset.quality) || 1);

	const clientWidth = rect.width * ratio;
	const clientHeight = rect.height * ratio;

	const videoWidth = Number(video.getAttribute('width'));
	const videoHeight = Number(video.getAttribute('height'));
	const videoRatio = videoWidth && videoHeight ? videoWidth / videoHeight : null;

	// De video vult zijn kader (object-fit: cover), dus bij een afwijkende
	// verhouding is er meer breedte nodig dan die van het kader zelf
	let width = clientWidth;

	if (videoRatio && clientHeight && clientWidth / clientHeight < videoRatio) {
		width = clientHeight * videoRatio;
	}

	// De kleinste bron die binnen de marge groot genoeg is, anders de grootste
	// die er is
	const minimum = width * SOURCE_TOLERANCE;
	const matched =
		sources.find((source) => Number(source.dataset.sourcewidth) >= minimum) ?? sources[sources.length - 1];

	if (video.src !== matched.src) {
		video.pause();
		video.src = matched.src;
		video.load();
	}

	return matched.src;
}
